'use strict';

import Api from "./Api";

export default class User extends Api {

    static getMe() {
        const url = this.url + 'user/me';

        return this.getAxios().get(url);
    }

    static getList(page = 1, perPage = 10) {
        const url = this.url + 'user/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
            },
        });
    }

    static get(id) {
        const url = this.url + 'user/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static update(data) {
        const url = this.url + 'user/update';

        return this.getAxios().post(url, data);
    }

    static updateAvatar(id, file) {
        const url = this.url + 'user/upload-avatar';

        const form = new FormData();
        form.append('id', id);
        form.append('avatar', file);

        return this.getAxios().post(url, form);
    }


    static add(data) {
        const url = this.url + 'user/add';

        return this.getAxios().post(url, data);
    }

    static changePassword(id, password, passwordRepeat) {
        const url = this.url + 'user/change-password';

        return this.getAxios().post(url, {
            id: id,
            password: password,
            password_repeat: passwordRepeat,
        });
    }

}